import { createGlobalStyle } from 'styled-components';
import { normalize } from './libraries/normalize';
import { theme } from './theme';
import './swiperSlides.css';
import { rem } from 'polished';

export const GlobalStyle = createGlobalStyle`
${normalize};
// ==========================================================================
// Global styles
// ==========================================================================
html {
  background-color: ${theme.color.background};
  color: ${theme.color.text};
  font-family: ${theme.global.font.family};
  font-size: 100%;
  line-height: 1.5;
  box-sizing: border-box;
  ${
    theme.global.font.smoothing
      ? `
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;`
      : ''
  }
}

//* {
//  border: solid 1px red;
//}

*, *:before, *:after {
  box-sizing: inherit;
}

body {
  /* Mobile fixed header height: 64px top row + 64px search row (HeaderMobile). */
  padding-top: ${rem(128)};
  /* The header is fixed on desktop regardless of the viewport height, so the
     content is always offset by its (measured) height. */
  ${theme.media('md')} {
    padding-top: ${(props) =>
      props.isCart
        ? rem(116)
        : props.isSimple
        ? rem(90)
        : `var(--header-height, ${rem(180)})`};
  }
}

@media print {
  body {
    padding-top: 0;
  }
}

// ==========================================================================
// Selection styles
// ==========================================================================
::selection {
  background: ${theme.color.selection};
  text-shadow: none;
}

// ==========================================================================
// Default img styles
// ==========================================================================
img {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  padding: 0;
}

a {
    color: ${theme.color.link};
    text-decoration: none;
    &:hover {
        text-decoration: underline;
    }
}

button,
input,
optgroup,
select,
textarea {
  font-family: ${theme.global.font.family};
}

body.side-cart-open #smartsupp-widget-container,
body.side-cart-open .smartsupp-widget-frame,
body.side-cart-open [class^='smartsupp'],
body.side-cart-open #chat-application,
body.mobile-menu-open #smartsupp-widget-container,
body.mobile-menu-open .smartsupp-widget-frame,
body.mobile-menu-open [class^='smartsupp'],
body.mobile-menu-open #chat-application,
body.hide-smartsupp #smartsupp-widget-container,
body.hide-smartsupp .smartsupp-widget-frame,
body.hide-smartsupp [class^='smartsupp'],
body.hide-smartsupp #chat-application {
  display: none !important;
}
`;
